"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function find(list, predicate) {
    if (!list)
        return null;
    for (var i = 0; i < list.length; i++) {
        if (predicate(list[i]))
            return list[i];
    }
    return null;
}
exports.find = find;
function findIndex(list, predicate) {
    if (!list)
        return -1;
    for (var i = 0; i < list.length; i++) {
        if (predicate(list[i]))
            return i;
    }
    return -1;
}
exports.findIndex = findIndex;
/**
 * Finds the first item in the specified list that matches the predicate.  If none are found,
 * returns the first item in the list or null if the list is empty.
 */
function findOrFirst(list, predicate) {
    list = list || [];
    var item = find(list, predicate);
    if (item) {
        return item;
    }
    return list.length > 0
        ? list[0]
        : null;
}
exports.findOrFirst = findOrFirst;
function remove(list, item) {
    var indexOfItem = list.indexOf(item);
    if (indexOfItem < 0)
        throw new Error("item not found in list");
    return list.slice(0, indexOfItem).concat(list.slice(indexOfItem + 1));
}
exports.remove = remove;
function removeIfPresent(list, item) {
    var indexOfItem = list.indexOf(item);
    if (indexOfItem < 0)
        return list;
    return list.slice(0, indexOfItem).concat(list.slice(indexOfItem + 1));
}
exports.removeIfPresent = removeIfPresent;
function removeItem(list, predicate) {
    if (!list)
        throw new Error('Input array cannot be null');
    var indexOfItemToRemove = findIndex(list, predicate);
    if (indexOfItemToRemove >= 0)
        return list.slice(0, indexOfItemToRemove).concat(list.slice(indexOfItemToRemove + 1));
    else
        return list.slice();
}
exports.removeItem = removeItem;
function clone(list) {
    return list.slice();
}
exports.clone = clone;
function first(list, n) {
    return list.slice(0, n);
}
exports.first = first;
function replaceItem(originalList, updatedItem, predicate) {
    return originalList.map(function (originalItem) {
        return predicate(originalItem)
            ? updatedItem
            : originalItem;
    });
}
exports.replaceItem = replaceItem;
function replaceItemBy(originalList, predicate, getUpdatedItem) {
    return originalList.map(function (originalItem) {
        return predicate(originalItem)
            ? getUpdatedItem(originalItem)
            : originalItem;
    });
}
exports.replaceItemBy = replaceItemBy;
function chunk(originalList, chunkSize) {
    var chunkedArrays = [];
    var i, j;
    for (i = 0, j = originalList.length; i < j; i += chunkSize) {
        chunkedArrays.push(originalList.slice(i, i + chunkSize));
    }
    return chunkedArrays;
}
exports.chunk = chunk;
